import { Autocomplete } from "stimulus-autocomplete";
Stimulus.register("autocomplete", Autocomplete);
